module.exports = __webpack_public_path__ + "img/Span-01.2eba1b03.jpg";